import { render, staticRenderFns } from "./CollectionRecordDetailsForm.vue?vue&type=template&id=5fc80f83&scoped=true"
import script from "./CollectionRecordDetailsForm.vue?vue&type=script&lang=js"
export * from "./CollectionRecordDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./CollectionRecordDetailsForm.vue?vue&type=style&index=0&id=5fc80f83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc80f83",
  null
  
)

export default component.exports